<footer>
  <div>
    {{version}}
  </div>
</footer>
